import { User } from "../UserService";
import { api } from "./api";

async function buscarTodosUsuarios() {
    return await api.get('/user/');
}

async function deletarUsuario(usuarioId: string | number) {
    return await api.patch(`/user/deletar/${usuarioId}`);
}

async function buscarPorUsuario(params = {}) {
    return await api.get('/user/buscarPorUsuario', {
        params: params
    });
}

async function buscarUsuarioPorId(id: string | number) {
    return await api.get(`/user/buscarUsuarioPorId/${id}`);
}

async function atualizarUsuario(usuarioId: string | number, usuario: User) {
    return await api.patch(`/user/${usuarioId}`, usuario);
}

export const usuarioApi = {
    buscarTodosUsuarios,
    deletarUsuario,
    buscarPorUsuario,
    buscarUsuarioPorId,
    atualizarUsuario
}